import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import EditableBubble from "./EditableBubble"; // your EditableBubble component
import App from "./new_mia"
import AudioBubble from "./AudioBubble";
import BannerBubble from "./BannerBubble";
import EditSubBubble from "./editSubBubble";
import { ToastContainer, toast } from "react-toastify";
import defaultData from "../demoDefaultData.json";
import "react-toastify/dist/ReactToastify.css";
import { getToken } from "../utils/auth";
import { Check } from "lucide-react";
import configData from "../config.json";
// Globe icon
const GlobeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={2}
    stroke="currentColor"
    style={{
      width: "24px",
      height: "24px",
      transform: "rotate(90deg)", // rotate 90 degrees
      transformOrigin: "center",   // rotate around the center
    }}
  >
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
    <path
      d="M12 2a10 10 0 0 1 0 20M12 2a10 10 0 0 0 0 20"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M2 12h20M2 12c2-4 6-6 10-6s8 2 10 6M2 12c2 4 6 6 10 6s8-2 10-6"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);

const LogoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ width: "24px", height: "24px" }}
  >
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" stroke="currentColor" />
    <circle cx="8" cy="8" r="2" stroke="currentColor" />
    <path d="M21 21l-6-6-5 5-3-3-2 2" stroke="currentColor" />
  </svg>
);


export default function MarketingAgent() {
  return(<App></App>)
}

// CSS-in-JS
const styles = {
  scrollContainer: {
    height: "100vh",
    overflowY: "auto",
    padding: "2rem 0",
  },
  container: {
    width: "100%",
    maxWidth: "800px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  title: {
    fontSize: "2.5rem",
    fontWeight: "bold",
    marginBottom: "2.5rem",
  },
  card: {
    width: "100%",
    padding: "1.5rem",
    backgroundColor: "#fff",
    borderRadius: "1rem",
    boxShadow: "0 10px 15px rgba(0,0,0,0.1)",
    marginBottom: "2rem",
  },
  inputRow: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  input: {
    flex: 1,
    padding: "0.5rem 1rem",
    borderRadius: "0.5rem",
    border: "1px solid #d1d5db",
    outline: "none",
  },
  langButton: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    padding: "0.5rem 1rem",
    borderRadius: "0.5rem",
    border: "1px solid #d1d5db",
    cursor: "pointer",
    backgroundColor: "#fff",
  },
  langDropdown: {
    position: "absolute",
    top: "calc(100% + 0.25rem)",
    right: 0,
    backgroundColor: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: "0.5rem",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    zIndex: 100,
  },
  langOption: {
    padding: "0.5rem 1rem",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  generateButton: {
    padding: "0.5rem 1.5rem",
    borderRadius: "0.5rem",
    border: "none",
    cursor: "pointer",
  },
  bubbleContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    width: "100%",
  },

};
